import styled, { css } from 'styled-components';
const BaseInputTextContainer = styled.div `
  display: inline-flex;
  position: relative;
  width: 100%;
  overflow: hidden;
  align-items: center;
  border-radius: 4px;
  border: 1px solid;
  margin-bottom: 8px;
  color: ${({ theme, disabled, readOnly }) => disabled || readOnly ? theme.colors.disabled03 : theme.colors.text01};
  border-color: ${({ error, theme }) => (error ? theme.colors.supportError01 : theme.colors.ui03)};
  background-color: ${({ disabled, readOnly, theme }) => readOnly || disabled ? theme.colors.disabled01 : theme.colors.ui01};
  flex-direction: ${({ iconPosition }) => (iconPosition === 'left' ? 'row-reverse' : 'row')};

  :focus-within {
    box-shadow: ${({ theme }) => theme.shadows.small};
  }

  svg {
    ${({ iconPosition }) => {
    switch (iconPosition) {
        case 'left':
            return css `
            margin-left: 12px;
          `;
        case 'right':
            return css `
            margin-right: 12px;
          `;
        default:
            return css `
            margin-right: 12px;
          `;
    }
}}
  }
`;
export default BaseInputTextContainer;
//# sourceMappingURL=BaseInputTextContainer.js.map